<template>
    <v-ons-page>

        <v-ons-toolbar class="main-toolbar branded"
                    :class="{'small-header': header_image == null }"
                    v-bind:style="{'height': header_image != null ? `calc(100% / 4)` : '56px'}">

            <img v-show="header_image != null"
                            class="outlet-header-image"
                            :src="header_image ? header_image : ''">

            <div class="left pressable">
                <a v-on:click="$router.go(-1)">
                    <svg class="icon-back" aria-hidden="true"></svg>
                </a>
            </div>
            <div class="center center-text">
                {{ outlet && header_image == null ? outlet.store_display_name : '' }}
            </div>
            <div class="right basket">
                <router-link v-if="outlet" v-bind:to="{ name: 'CreateOrder' }" v-bind:class=" { boing: basket_flash }">
                    <svg class="icon-basket" aria-hidden="true"></svg>
                </router-link>
            </div>
        </v-ons-toolbar>

        <div class="content" v-bind:style="{'top': header_image != null ? 'calc(100% / 4)' : '56px'}">

            <div class="content-inner">

                <div class="main-header left mb-30 mt-30">
                    {{ selected_product ? selected_product.product_name : '' }}
                </div>

                <template v-if="selected_product">
                    <!-- Attribute select -->
                    <v-ons-list v-if="selected_product.has_attributes">
                        <v-ons-list-header class="sub-header left">Please choose from the following options</v-ons-list-header>
                        <template v-for="attribute in sorted_attributes">
                            <v-ons-list-item v-bind:key="attribute.name" v-if="attribute.show">
                                <div class="left">
                                    <span class="list-item__title">{{ attribute.name }}</span>
                                </div>
                                <div class="right">
                                    <v-ons-select v-if="attribute.has_options"
                                                  v-model="attributes[attribute.name].value"
                                                  v-on:change="changeAttribute(attribute.index)">
                                        <option v-for="option in attributes[attribute.name].available_options">
                                            {{ option }}
                                        </option>
                                    </v-ons-select>
                                    <v-ons-input v-else placeholder="Enter option"
                                                 v-model="attributes[attribute.name].value"></v-ons-input>
                                </div>
                            </v-ons-list-item>
                        </template>
                        <section class="section-vh">
                            <gtc-button v-on:click="addAttribute" modifier="large"
                                          v-bind:disabled="!can_add_attribute" class="btn-action branded">
                                {{ add_attribute_label }}
                            </gtc-button>
                        </section>
                        <section class="section-vh">
                            <gtc-button v-on:click="clearAttributes(0)" modifier="large"
                                          v-show="show_clear_attributes_button" class="secondary">
                                Clear options
                            </gtc-button>
                        </section>
                    </v-ons-list>

                    <!-- Variant select -->
                    <v-ons-list v-if="selected_product.has_attributes == false && selected_product.variants.length > 0"
                        data-test-id="cnt-products">
                        <v-ons-list-header class="sub-header left">Please select from the following options</v-ons-list-header>
                        <template v-for="product in selected_product.variants">
                            <product-menu-list-item
                                    v-on:click="variantClick(product, 1)"
                                    v-bind:key="product.product_id"
                                    v-bind:product="product"
                                    v-bind:basket="order.baskets[product_outlet.id]"
                                    v-bind:truncate_description="false"/>
                        </template>
                    </v-ons-list>

                    <!-- Modifier select -->
                    <template v-if="selected_product.variants.length == 0 && selected_product.modifier_sets.length > 0">
                        <v-ons-list class="list-modifiers" v-for="(modifier_set, modifier_set_index) in selected_product.modifier_sets"  :key="modifier_set_index" >
                            <v-ons-list-header class="sub-header left">{{ modifierSetLabel(modifier_set) }}</v-ons-list-header>
                            <v-ons-list-item
                                v-for="modifier in modifier_set.modifiers"
                                v-bind:key="`${modifier_set_index}-${modifier.modifier_id}`">
                                <div class="left quantity-container">
                                    <i class="fa fa-minus-circle pressable quantity-button" aria-hidden="true"
                                       v-bind:style="{ visibility: modifiers[`${modifier_set_index}-${modifier.modifier_id}`].quantity > 0 && modifier_set.max_qty != 1 ? 'visible' : 'hidden' }"
                                       v-on:click="changeModifierQuantity(`${modifier_set_index}-${modifier.modifier_id}`, 'subtract')"></i>
                                    <v-ons-checkbox
                                        v-on:click="changeModifierQuantity(`${modifier_set_index}-${modifier.modifier_id}`, 'toggle', $event)"
                                        v-bind:checked="modifiers[`${modifier_set_index}-${modifier.modifier_id}`].quantity > 0"
                                        class="pressable"></v-ons-checkbox>
                                    <i class="fa fa-plus-circle pressable quantity-button" aria-hidden="true"
                                       v-bind:style="{ visibility: modifiers[`${modifier_set_index}-${modifier.modifier_id}`].quantity > 0 && modifier_set.max_qty != 1 ? 'visible' : 'hidden' }"
                                       v-on:click="changeModifierQuantity(`${modifier_set_index}-${modifier.modifier_id}`, 'add')"></i>
                                </div>
                                <div class="center">
                                    <span class="list-item__title regular-text">
                                        {{ modifier.modifier_name }}
                                       <span v-if="modifiers[`${modifier_set_index}-${modifier.modifier_id}`].quantity > 0" class="label-basket">
                                           <i class="fa fa-shopping-basket"></i>
                                           <template v-if="modifier_set.max_qty != 1">
                                               {{ modifiers[`${modifier_set_index}-${modifier.modifier_id}`].quantity }} added to product
                                           </template>
                                           <template v-else>
                                               Added to product
                                           </template>
                                        </span>
                                    </span>
                                </div>
                                <div class="right item-price-text">
                                    {{ filters.money(parseFloat(modifier.price), true, outlet.currency_symbol) }}
                                </div>
                            </v-ons-list-item>
                        </v-ons-list>

                        <div class="spacer spacer_menu_list_bottom"></div>

                        <section class="section-vh big-button-container" v-if="selected_product.variants.length == 0 && selected_product.modifier_sets.length > 0">
                            <gtc-button class="btn-action branded" v-on:click="productAdd(selected_product, 1)">
                                {{ add_modifier_label }}
                            </gtc-button>
                        </section>
                    </template>

                </template>
            </div>
        </div>

        <v-ons-alert-dialog
                title="Please check the following options:"
                v-bind:visible.sync="modifier_alert.show"
                v-bind:footer="{ OK: () => modifier_alert.show = false }">
            <ul>
                <li v-for="modifier_error in modifier_alert.errors">
                    {{ modifier_error }}
                </li>
            </ul>
        </v-ons-alert-dialog>
    </v-ons-page>

</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    import { default as WhenOutletLoadedMixin } from '../../mixins/whenoutletloaded'
    import { default as BrowseOnlyMixin } from '../../mixins/browse_only'
    import ProductMenuListItem from '../fragments/product_menu_list_item'

    export default {

        mixins: [WhenOutletLoadedMixin, BrowseOnlyMixin],

        props: [
            'root_product_id',
            'previous_text_attributes',
        ],

        components : {
            'product-menu-list-item': ProductMenuListItem,
        },

        created() {

        },

        mounted() {

            this.product_outlet = this.$route.params.product_outlet

            // If refresh, we wont have the product_outlet, so redirect to the menu
            if (this.product_outlet == null) {
                return this.$router.replace({ name: 'Menu', params: { outlet_slug: this.outlet.slug } })
            }

        },

        data () {
            return {
                app: this.$root.$data.app,
                selected_product: null,
                product_outlet: null,
                modifiers: null,
                attributes: null,
                modifier_price: 0,
                attribute_variant: null,
                modifier_alert: {
                    show: false,
                    errors: [],
                },
                basket_flash: false,
            }
        },

        methods : {

            ...mapMutations([
                'addProduct',
            ]),

            whenOutletLoaded(){

                this.setProduct()
            },

            variantClick(product, quantity){

                if (product.is_available == false) {
                    this.$ons.notification.alert(
                        `${product.product_name} is currently unavailable.`,
                        {
                            title: 'Unavailable',
                            buttonLabels: ['Close']
                        },
                    )
                    return
                }

                if (product.modifier_sets.length > 0) {

                    this.$router.push({
                        name: 'Modifiers',
                        params: {
                            id: product.product_id,
                            root_product_id: this.$route.params.root_product_id,
                            previous_text_attributes: this.text_attributes,
                            product_outlet: this.product_outlet,
                        }
                    })
                } else {
                    this.productAdd(product, quantity)
                }
            },

            addAttribute: function(){

                this.variantClick(this.attribute_variant, 1)
            },

            productAdd: function(product, quantity) {

                if (product.is_available == false) {
                    this.$ons.notification.alert(
                        `${product.product_name} is currently unavailable.`,
                        {
                            title: 'Unavailable',
                            buttonLabels: ['Close']
                        },
                    )
                    return
                }

                const modifier_validation_errors = this.validateModifiers()
                if (modifier_validation_errors.length > 0){
                    this.modifier_alert.errors = modifier_validation_errors
                    this.modifier_alert.show = true
                    return
                }

                if (this.browse_only)
                    return this.handleBrowseInteract(true)

                this.basketFlash()

                let ta = this.text_attributes
                if (this.text_attributes.length == 0)
                    ta = this.$route.params.previous_text_attributes

                this.addProduct({
                    product,
                    quantity,
                    modifiers: Object.values(this.modifiers).filter(m => m.quantity > 0),
                    root_product_id: this.$route.params.root_product_id,
                    text_attributes: ta,
                    outlet: this.$route.params.product_outlet,
                })

                this.app.trackFbEvent(
                    'AddToCart',
                    {
                        'content_name': product.product_name,
                    },
                )

                this.$router.push({ name: 'Menu', params: { outlet_slug: this.outlet.slug } })
            },

            basketFlash(){
                this.basket_flash = true
                setTimeout(() => this.basket_flash = false, 300)
            },

            setProduct(){
                const selected_product_id = this.$route.params.id

                // Find this product
                this.$route.params.product_outlet.menu.forEach(category => {
                    category.items.forEach(product => {
                        if (product.product_id == selected_product_id){
                            this.selected_product = product
                            return
                        }
                        product.variants.forEach(variant => {
                            if (variant.product_id == selected_product_id){
                                this.selected_product = variant
                                return
                            }
                        })
                    })
                })

                // Setup modifiers object
                this.modifiers = this.selected_product.modifier_sets.reduce((carry, modifier_set, modifier_set_index) => {
                    modifier_set.modifiers.forEach(modifier => {
                        const compound_key = `${modifier_set_index}-${modifier.modifier_id}`
                        carry[compound_key] = {
                            index: modifier_set_index,
                            set_id: modifier_set.id,
                            id: modifier.modifier_id,
                            price: modifier.price,
                            name: modifier.modifier_name,
                            quantity: 0,
                            modifier_set,
                        }
                    })
                    return carry
                }, {})

                // Setup attributes object
                this.attributes = {}
                this.selected_product.attributes.forEach((attribute, index) => {
                    this.attributes[attribute.name] = {
                        name: attribute.name,
                        has_options: false,
                        available_options: [],
                        index,
                        show: true,
                        value: null,
                    }
                })

                // Determine whether each attribute has options
                this.selected_product.variants
                    .forEach(variant => {
                        variant.attributes.forEach((attribute, index) => {
                            // Add options
                            if (attribute.value.length > 0)
                                this.attributes[attribute.name].has_options = true
                        })
                    })

                // Set the order of the attributes
                this.sorted_attributes.forEach((attribute, index) => attribute.index = index)

                this.calculateAttributeAvailableValues()

                this.setModifierPrice()
            },

            calculateAttributeAvailableValues(){

                this.selected_product.variants.forEach(variant => {

                    // Loop through variant values that have been populated
                    variant.attributes
                        .filter(variant_attr => variant_attr.value != '')
                        .forEach(variant_attr => {

                            const name = variant_attr.name
                            const value = variant_attr.value
                            const attr = this.attributes[name]

                            if (value != null && attr.has_options && attr.available_options.includes(value) == false)
                                attr.available_options.push(value)
                        })
                })
            },

            clearAttributes(start_index=0){

                this.sorted_attributes
                    .filter(attr => attr.has_options)
                    .filter((attr, index) => index >= start_index)
                    .forEach((attr, index) => {
                        attr.value = null
                    })

                this.calculateAttributeAvailableValues()
            },

            changeAttribute(index){

                this.attribute_variant = this.getAttributeVariant()
            },

            setModifierPrice(){

                let cost = parseFloat(this.selected_product.selling_price)
                cost += Object.values(this.modifiers)
                    .reduce((carry, modifier) => carry + (parseFloat(modifier.price) * modifier.quantity), 0)

                this.modifier_price = cost
            },

            getAttributeVariant(){

                if (this.selected_product.has_attributes == false)
                    return null

                // Find a variant with all attributes matching the parent
                return this.selected_product.variants.find(variant => {
                    // Map variant attributes
                    const map = Object.values(variant.attributes)
                        .reduce((carry, attr) => {
                            carry[attr.name] = attr.value
                            return carry
                        }, {})

                    const count = this.option_attributes.length
                    return this.option_attributes
                        .filter(attr => map.hasOwnProperty(attr.name) && map[attr.name] == attr.value).length == count
                })
            },

            modifierSetLabel(modifier_set) {

                const option_plural = (quantity) => this.filters.pluralise(quantity, 'option', 'options')

                let label = modifier_set.name

                if (modifier_set.min_qty > 0 && modifier_set.max_qty > 0) {
                    if (modifier_set.min_qty == modifier_set.max_qty) {
                        if (modifier_set.min_qty == 1)
                            label += ` - Choose an option`
                        else
                            label += ` - Choose ${modifier_set.min_qty} ${option_plural(modifier_set.min_qty)}`
                    } else {
                        label += ` - Choose between ${modifier_set.min_qty} and ${modifier_set.max_qty} options`
                    }
                } else if (modifier_set.min_qty > 0){
                    label += ` - Choose at least ${modifier_set.min_qty} ${option_plural(modifier_set.min_qty)}`
                } else if (modifier_set.max_qty > 0) {
                    label += ` - Choose up to ${modifier_set.max_qty} ${option_plural(modifier_set.max_qty)}`
                }

                return label
            },

            validateModifiers(){
                return this.selected_product.modifier_sets
                    .map((ms, index) => {
                        ms.index = index
                        return ms
                    })
                    .filter(ms => ms.min_qty > 0 || ms.max_qty > 0)
                    .map(ms => {
                        // Tally entries
                        const count = Object.values(this.modifiers)
                            .filter(m => m.index == ms.index)
                            .reduce((carry, m) => carry + m.quantity, 0)

                        // Check count
                        if (count < ms.min_qty)
                            return `The ${ms.name} quantity is less than the minimum of ${ms.min_qty}`
                        else if (ms.max_qty > 0 && count > ms.max_qty)
                            return `The ${ms.name} quantity is more than the maximum of ${ms.max_qty}`

                        return null
                    })
                    .filter(e => e != null)
            },

            changeModifierQuantity(index, action, event) {
                const modifier = this.modifiers[index]
                const quantity_in_set = Object.values(this.modifiers)
                    .reduce((carry, element) => {
                        if (element.modifier_set.id == modifier.modifier_set.id)
                            carry += element.quantity
                        return carry
                    }, 0)
                const max_in_set = modifier.modifier_set.max_qty

                if (action == 'add') {
                    if (max_in_set == 0 || quantity_in_set + 1 <= max_in_set)
                        modifier.quantity += 1
                } else if (action == 'subtract'){
                    if (modifier.quantity > 0)
                        modifier.quantity -= 1
                } else if (action == 'toggle') {
                    const new_value = modifier.quantity == 0 ? 1 : 0
                    if (max_in_set == 0 || quantity_in_set + new_value <= max_in_set)
                        modifier.quantity = new_value
                    else if (event)
                        event.preventDefault()
                } else {
                    throw new Error(`Unknown action ${action}`)
                }
                this.setModifierPrice()
            },
        },

        computed: {

            ...mapGetters([
                'order',
                'basketInfo',
                'outlet',
                'browse_only',
            ]),

            can_add_attribute: function(){
                return this.attribute_variant != null && this.attribute_variant.is_available
            },

            sorted_attributes: function(){
                let values = Object.values(this.attributes)
                values.sort((a, b) => {
                    let a_val = a.has_options == false ? a.index + 100 : a.index
                    let b_val = b.has_options == false ? b.index + 100 : b.index
                    return a_val - b_val
                })
                return values
            },

            populated_attributes: function(){
                return this.sorted_attributes
                    .filter(attr => attr.has_options)
                    .filter(attr => attr.value != null)
                    .reduce((carry, attr) => {
                        carry[attr.name] = attr.value
                        return carry
                    }, {})
            },

            add_attribute_label: function(){

                if (this.attribute_variant == null)
                    return 'Not available'

                if (this.attribute_variant.is_available == false)
                    return 'Currently unavailable'

                const attribute_variant = this.attribute_variant

                return `Add to basket for ${this.filters.money(attribute_variant.selling_price, true, this.outlet.currency_symbol)}`
            },

            add_modifier_label: function(){

                return `Add to basket for ${this.filters.money(this.modifier_price, true, this.outlet.currency_symbol)}`
            },

            option_attributes: function(){

                if (this.attributes == null)
                    return []

                return Object.values(this.attributes).filter(attr => attr.has_options)
            },

            show_text_attributes: function(){
                return true
            },

            text_attributes: function(){

                if (this.attributes == null)
                    return []

                return Object.values(this.attributes)
                    .filter(attr => attr.has_options == false)
                    .filter(attr => attr.value)
                    .map(attr => ({
                        name: attr.name,
                        value: attr.value,
                    }))
            },

            show_clear_attributes_button: function(){
                return Object.values(this.populated_attributes).length > 1
            },

            header_image: function(){
                return this.selected_product && this.helpers.stringEmpty(this.selected_product.image) == false ?
                    this.selected_product.image : null
            },
        },

        watch: {

            modifiers: {
                deep: true,
                handler: function() {
                    if (!this.selected_product)
                        return

                    this.setModifierPrice()
                }
            },

            selected_product: function(value) {

                if (value == null)
                    return

                const content_name = `Product - ${value.product_name}`

                this.app.trackFbEvent(
                    'PageView',
                    {
                        content_name
                    }
                )

                this.app.trackFbEvent(
                    'ViewContent',
                    {
                        content_name
                    }
                )
            }
        }
    }
</script>

<style scoped>
    .quantity-container {
        color: #62D6B6;
        font-size: 18px;
    }

    .quantity-button {
        color: #62D6B6;
    }

    .spacer {
        width: 100%;
    }

    .spacer.spacer_menu_list_bottom {
        height: 70px;
    }

    .center-text{
        text-align: center;
    }

    .quantity-container, .remove-container {
        margin-right: 0px;
        width: 80px;
        text-align: center;
    }

    .main-header{
        font-size: 25px;
    }

    ons-list-header {
        padding: 0px! important;
    }

    .list-modifiers {
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/order/product.vue